import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Martín S.',
  role: 'Profe de Infantiles, CABA',
  text: 'Me salvó la vida con los más chicos. Antes era un caos mantenerlos enfocados, ahora con los juegos del Capítulo 2 tengo las clases armadas para todo el mes.'
}, {
  name: 'Luciana G.',
  role: 'Entrenadora Cadetes, Córdoba',
  text: 'Increíble la cantidad de variantes tácticas. Mis equipos mejoraron muchísimo la defensa 5:1 desde que aplico los drills del manual. Súper recomendado.'
}, {
  name: 'Federico M.',
  role: 'Profe de Educación Física, Rosario',
  text: 'Llegaba a la escuela sin saber qué dar porque me faltaban materiales. El módulo de emergencias es oro puro. Resolvés con lo que tenés a mano.'
}, {
  name: 'Diego R.',
  role: 'Entrenador Mayores, Mendoza',
  text: 'El nivel de detalle en la preparación física y prevención de lesiones vale cada peso. Mis jugadores llegan enteros al final del torneo.'
}, {
  name: 'Camila V.',
  role: 'Profe de Minis, Neuquén',
  text: 'Las planillas de seguimiento me organizaron todo el trabajo administrativo que antes me llevaba horas. Ahora solo me dedico a enseñar.'
}];
export function Testimonials() {
  return <section className="py-16 px-4 bg-blue-900 text-white" data-id="element-135">
      <div className="max-w-6xl mx-auto" data-id="element-136">
        <h2 className="text-3xl md:text-4xl font-oswald font-bold text-center mb-12 uppercase" data-id="element-137">
          Profes que ya{' '}
          <span className="text-blue-300" data-id="element-138">transformaron sus clases</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-139">
          {testimonials.map((t, i) => <div key={i} className="bg-blue-800 p-6 rounded-xl border border-blue-700 flex flex-col" data-id="element-140">
              <div className="flex gap-1 mb-4" data-id="element-141">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-white fill-white" data-id="element-142" />)}
              </div>
              <p className="text-blue-100 italic mb-6 flex-grow" data-id="element-143">"{t.text}"</p>
              <div className="border-t border-blue-700 pt-4 mt-auto" data-id="element-144">
                <h4 className="font-bold text-white" data-id="element-145">{t.name}</h4>
                <p className="text-sm text-blue-300" data-id="element-146">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}